<div class="account-page">



  <app-account-details />

</div>
